import React from "react";
import { useHorizontalScroll } from "../../lib/hooks/useHorizontalScroll";
import RoadmapItem from "./RoadmapItem";

const Roadmap = () => {
  const roadmap_items = [
    {
      roadmapTitle: "2026",
      title: "Foundations",
      info: [
        "• Deliver the MVP (Minimal Viable Product) with core platform functionality.",
        "• Complete initial token sale and establish basic liquidity.",
        "• Begin forming strategic partnerships for early platform integrations.",
      ],
    },
    {
      roadmapTitle: "2027",
      title: "Growth & User Acquisition",
      info: [
        "• Expand user base through targeted marketing and community campaigns.",
        "• Improve token accessibility with new exchange listings.",
        "• Strengthen existing partnerships and onboard new platforms",
      ],
    },

    {
      roadmapTitle: "2028",
      title: "Ecosystem Expansion & Governance",
      info: [
        "• Introduce decentralized governance",
        "• Enhance platform features (e.g., advanced privacy layers, tiered subscriptions, VR streaming)",
        "• Refine token economics as platform utility increases ",
      ],
    },

    {
      roadmapTitle: "2029",
      title: "Internationalization & Maturity",
      info: [
        "• Enter new geographic markets with localized content and compliance.",
        "• Maintain platform scalability and robust security as user numbers grow.",
        "• Manage token emissions responsibly as team vesting nears completion.",
      ],
    },
    {
      roadmapTitle: "2030",
      title: "Stability & Sustainability",
      info: [
        "• Achieve a self-sustaining ecosystem with stable revenue streams.",
        "• Maintain balanced tokenomics and community-driven governance.",
        "• Cement the project’s leadership role and philanthropic impact.",
      ],
    },

  ];

  const scrollRef = useHorizontalScroll();

  return (
    <section id="roadmap" className="roadmap-area pt-130 pb-130">
      <div className="container custom-container-two">
        <div className="row justify-content-md-center">
          <div className="col-xl-5 col-lg-8">
            <div className="section-title text-md-center mb-60">
              <span className="sub-title">OUr Roadmap</span>
              <h2 className="title">
                Curtezan Strategy and <br /> Project <span>Plan</span>
              </h2>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-12">
            <div
              className="bt-roadmap_x bt-roadmap-scrollbar"
            >
              <div className="bt-roadmap-wrap">
                {roadmap_items.map((x, index) => (
                  <RoadmapItem key={index} item={x} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Roadmap;
